(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nt-article-reviews"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const loadArticleReviews = () => {
    if (!document.querySelector('[data-nt-article-reviews]')) return;
    const platformUrl = 'https://elfsightcdn.com/platform.js';
    const alreadyLoaded = Array.from(document.scripts).some((script) =>
      script.src === platformUrl ||
      script.src === 'https://static.elfsight.com/platform/platform.js'
    );
    if (alreadyLoaded) return;
    const script = document.createElement('script');
    script.src = platformUrl;
    script.async = true;
    script.dataset.ntArticleReviewsLoader = 'true';
    document.head.appendChild(script);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadArticleReviews, { once: true });
  } else {
    loadArticleReviews();
  }
  document.addEventListener('shopify:section:load', loadArticleReviews);
})();
  } catch(e) { console.error(e); }
})();

})();
